import React, {useState, useCallback} from 'react';
import Cookies from 'js-cookie';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {ModalsStore} from 'app/store/ModalsStore';
import {inject} from 'mobx-react';
import {observer} from 'mobx-react-lite';
import {isDesktop} from 'app/utils';
import I18n from 'app/i18n';

const EXPIRES_DATE = 1825;

interface CookiesPolicyInterface {
    modalsStore?: ModalsStore
}

const CookiesPolicy = inject('modalsStore')(observer((props: CookiesPolicyInterface) => {
    const [isVisible, setIsVisible] = useState(!Cookies.get('cookies_policy'));
    const [isRendered, setIsRendered] = useState(isVisible);
    const {modalsStore} = props;
    const hasModals = modalsStore.collection.length > 0;
    const hidePanel = !isVisible || hasModals && !isDesktop();

    const acceptCookiesPolicy = useCallback(() => {
        Cookies.set('cookies_policy', '1', {expires: EXPIRES_DATE});
        setIsVisible(false);
    }, []);

    const handleAnimationEnd = useCallback((e: React.AnimationEvent) => {
        if (!isVisible && e.animationName === 'cookies-hide') {
            setIsRendered(false);
        }
    }, [isVisible]);


    if (!isRendered) {
        return null;
    }

    return <div className={`cookies-panel ${hidePanel ? 'cookies-panel--hidden' : ''}`}>
        <div onAnimationEnd={handleAnimationEnd} className="cookies-panel__wrap">
            <div className="cookies-panel__top">
                <SpriteIcon name="#svg-notif-system" className="cookies-panel__top-icon" />
                <span className="cookies-panel__top-text">{I18n.t('cookies_policy_text')}</span>
            </div>
            <button className="cookies-panel__close" onClick={acceptCookiesPolicy}>{I18n.t('cookies_policy_button')}</button>
        </div>
    </div>;
}));

export default CookiesPolicy;
